
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-10---autofocus"}}>{`Ex. 10 - Autofocus`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons faire en sorte que le champs de recherche soit "focus" automatiquement. Nous pourrions utiliser l'`}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://developer.mozilla.org/en-US/docs/Web/API/HTMLSelectElement/autofocus"}}>{`attribut autofocus`}</MDXTag>{` mais ce serait non contrôlé 😬.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Modifier `}<MDXTag name="inlineCode" components={components} parentName="li">{`SearchInput`}</MDXTag>{` afin de supporter une `}<MDXTag name="inlineCode" components={components} parentName="li">{`ref`}</MDXTag>{` et la fonction `}<MDXTag name="inlineCode" components={components} parentName="li">{`ref.current.focus()`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`A l'aide de `}<MDXTag name="inlineCode" components={components} parentName="li">{`useRef`}</MDXTag>{` et `}<MDXTag name="inlineCode" components={components} parentName="li">{`useEffect`}</MDXTag>{`, faire en sorte que le champs soit focus automatiquement dans `}<MDXTag name="inlineCode" components={components} parentName="li">{`App`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Le champs est focus automatiquement au démarrage de l'application.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-10/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"forward-ref"}}>{`Forward ref`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`import React from 'react'

export default React.forwardRef(function MyInput(props, ref) {
  return <input ref={ref} {...props} />
})
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"utilisation-dune-ref"}}>{`Utilisation d'une ref`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`function Example() {
  const inputRef = useRef()

  useEffect(() => {
    inputRef.current.focus()
  }, [])

  return <input ref={inputRef} />
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  